import React from 'react';
import PropTypes from 'prop-types';
import styles from './InfoPopup.scss';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CloseIcon from '@material-ui/icons/Close';


const InfoPopup =  React.forwardRef((props, ref) => {
  const {
    open,
    onCloseHandler,
    title,
    content,
  } = props;
  
  return <Popper
    testid={'infoPopup'}
    anchorEl={() => ref.current}
    className={styles.infoContainer}
    open={open}
    onClose={onCloseHandler}
    placement="bottom-end"
  >
    <ClickAwayListener onClickAway={onCloseHandler}>
      <div className={styles.infoContentContainer}>
        <div className={styles.infoTitleContainer}>
          <span testid={'infoPopupTitle'} className={styles.infoTitleText}>{title}</span>
          <CloseIcon testid={'infoPopupCloseIcon'} fontSize={'medium'} onClick={onCloseHandler}/>
        </div>
        <div className={styles.infoBodyContainer}>
          {content}
        </div>
      </div>
    </ClickAwayListener>
  </Popper>;
});

InfoPopup.propTypes = {
  open: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
};
export default InfoPopup;